import React from "react";

import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAUUIH_V6at0_Bd7G1fZqNniSaoUaXs0i8",
  authDomain: location.host.includes("localhost") ? "adic-mobile-app.firebaseapp.com" : location.host,
  projectId: "adic-mobile-app",
  storageBucket: "adic-mobile-app.appspot.com",
  messagingSenderId: "723504900972",
  appId: "1:723504900972:web:7cd78b078b4fbfc818e149",
  measurementId: "G-SD701136KF"
};

const app = initializeApp(firebaseConfig);
const fireBaseAuth = getAuth(app);

export { app, fireBaseAuth };
